import { render, staticRenderFns } from "./footNav.vue?vue&type=template&id=b50a6340&scoped=true&"
import script from "./footNav.vue?vue&type=script&lang=js&"
export * from "./footNav.vue?vue&type=script&lang=js&"
import style0 from "./footNav.vue?vue&type=style&index=0&id=b50a6340&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50a6340",
  null
  
)

export default component.exports